import { render } from "./InactivarCodigos.vue?vue&type=template&id=17443316&scoped=true"
import script from "./InactivarCodigos.vue?vue&type=script&lang=js"
export * from "./InactivarCodigos.vue?vue&type=script&lang=js"

import "./InactivarCodigos.vue?vue&type=style&index=0&id=17443316&scoped=true&lang=css"

import exportComponent from "C:\\Software\\Aplicaciones\\allikamay\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-17443316"]])

export default __exports__